import { useTranslation } from "react-i18next";
import { Form, InputGroup, Row, Col } from "react-bootstrap";

interface PropTypes {
    companyWebsiteURL: string;
    setCompanyWebsiteURL: Function;
    companyName: string;
    setCompanyName: Function;
}

const EditCompanyInformation = (props: PropTypes) => {

    const { companyWebsiteURL, setCompanyWebsiteURL, companyName, setCompanyName } = props;
    const { t } = useTranslation();

    return (
        <div className="border-bottom">
            {/* <div className="card-header">
                <h2 className="mb-0 h6">{t("Company Information")}</h2>
            </div> */}

            <div className="card-body">
                <Form>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Label htmlFor="companyName">
                                {t("Company Name")}
                            </Form.Label>
                            <InputGroup className="input-group-outline">
                                <Form.Control
                                    size="lg"
                                    id="companyName"
                                    type="text"
                                    value={companyName}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                        setCompanyName(e.target.value)
                                    }
                                    required
                                />
                            </InputGroup>
                        </Col>

                        <Col md={6}>
                            <Form.Label htmlFor="companyWebsiteURL">
                                {t("Website")}
                            </Form.Label>
                            <InputGroup className="input-group-outline">
                                <Form.Control
                                    size="lg"
                                    id="companyWebsiteURL"
                                    type="text"
                                    value={companyWebsiteURL}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                        setCompanyWebsiteURL(e.target.value)
                                    }
                                    required
                                />
                            </InputGroup>
                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    );
};

export default EditCompanyInformation;